export const TEST_ID = 'updateFarmForm';

export const FORM = 'form';

export const CONFIRM = 'confirm';
